export const TAROT_SPREADS = {
  daily: {
    id: 'daily',
    nameTh: 'ไพ่ประจำวัน',
    description: 'เปิดไพ่ 1 ใบ รับพลังและคำแนะนำสำหรับวันนี้',
    cardCount: 1,
    positions: [{ key: 'today', labelTh: 'พลังวันนี้' }],
    icon: '☀',
  },
  path: {
    id: 'path',
    nameTh: 'อดีต · ปัจจุบัน · อนาคต',
    description: 'ไพ่ 3 ใบ มองภาพรวมเส้นทางชีวิตของคุณ',
    cardCount: 3,
    positions: [
      { key: 'past', labelTh: 'อดีต' },
      { key: 'present', labelTh: 'ปัจจุบัน' },
      { key: 'future', labelTh: 'อนาคต' },
    ],
    icon: '☸',
  },
  lotto: {
    id: 'lotto',
    nameTh: 'เลขนำโชคจากไพ่',
    description: 'ไพ่ 3 ใบ พิเศษสำหรับ Hotto — พลังโชค สิ่งกีดขวาง และเลขนำทาง',
    cardCount: 3,
    positions: [
      { key: 'luck', labelTh: 'พลังโชค' },
      { key: 'block', labelTh: 'สิ่งกีดขวาง' },
      { key: 'guide', labelTh: 'เลขนำทาง' },
    ],
    icon: '✨',
    hotto: true,
  },
};

export function getSpread(id) {
  return TAROT_SPREADS[id] ?? TAROT_SPREADS.daily;
}
